import React from 'react';

/**
 * An image slot that always keeps its shape.
 *
 * TMDB is missing artwork for plenty of long-tail titles, so instead of a
 * broken image or a collapsed card, the slot falls back to a hatched plate
 * labelled with what should have been there.
 */
const Art = ({ src, alt = '', label, className = '', children }) => (
  <div className={`art ${className}`}>
    {src ? (
      <img src={src} alt={alt} loading="lazy" />
    ) : (
      label && <span className="art-label">{label}</span>
    )}
    {children}
  </div>
);

export default Art;
